import {createRequestDataSource} from '@ngneat/elf-requests';
import {select} from '@ngneat/elf';

import {clientDetailsStore} from '@store/clients/details/client-details.store';
import {ManageOrganisation} from '@store/common/organisation.model';
import {ClientDetails} from '@store/clients/details/client-details.model';

export const getClientDetailsDataSource = createRequestDataSource({
  store: clientDetailsStore,
  data$: () => clientDetailsStore.pipe(select((state) => state as ManageOrganisation)),
  requestKey: 'getClientDetails',
  dataKey: 'headOffice',
});

export const putClientFacturationModeDataSource = createRequestDataSource({
  store: clientDetailsStore,
  data$: () => clientDetailsStore.pipe(select((state) => state as ClientDetails)),
  requestKey: 'putClientFacturationMode',
  dataKey: 'client',
});
